import { EditcontrolledareacameraComponent } from "src/app/features/parking/accesscontrol/controlledareas/edit/editcontrolledareacamera/editcontrolledareacamera.component";
import { LevelEditorComponent } from "../../leveleditor.component";
import { PointMapComponent } from "./PointMapComponent";

export class Camera extends PointMapComponent{
    public override ClassName: string = "Camera";
    public override ImageUrl: string = "/assets/leveleditor/camera.png";
    public override ImageScale = 0.05;
    public override RequiresParent: boolean = true;
    public override ParentClassName: string = "Lane";
    
    constructor(leveleditorcomponent: LevelEditorComponent, canvas: any, formItem: any, parentFormItem: any, forceClone: boolean = false) {
        super(leveleditorcomponent, canvas, formItem, parentFormItem, forceClone);
        this.AddFabricItem();
    }

    public override Clone(formitem: any){
        return new Camera(this.leveleditorcomponent, this.canvas, formitem, this.parentFormItem, true);
    }

    public override ShowModal(): void {
        this.leveleditorcomponent.modalService.addModal(EditcontrolledareacameraComponent, { Form: this.formItem })
        .subscribe((result) => {
        });
    }
}
